var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"start-page"},[(_vm.loader)?_c('div',{staticClass:"loader"},[_c('b-spinner',{attrs:{"variant":"primary","type":"grow","label":((this.$t('reports.loadingLabel')) + "...")}})],1):_c('div',[_c('highcharts',{attrs:{"options":_vm.chartOptions}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9df9eeb4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/molecules/highcharts/reports/evolution-percentage.vue
// module id = null
// module chunks = 